const config = {
  // API_ENDPOINT: 'http://localhost:5001/api',
  API_ENDPOINT: 'https://gsoc-311.web.app/api'
};

export default config;
